import { Button, Checkbox, FormControlLabel, Grid, IconButton, Popover, TextField, Tooltip } from "@material-ui/core";
import { Alert } from '@mui/material';
import { IconSettings } from "icons";
import { useEffect, useState } from "react";
import { columnCustomizationPanelStyle } from "./style";

const TableCustomizationPanel = ({
    columns,
    selectedColumns,
    onSaveColumns,
    isCustomized,
    onReset,
    resetting,
    title = 'Customize View',
    showTip
}) => {


    const classes = columnCustomizationPanelStyle();
    const [configureColumns, setConfigureColumns] = useState(false);
    const [checkedChanged, setCheckedChanged] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [selectedColumnKeys, setSelectedColumnKeys] = useState(selectedColumns?.map(s => s.key));

    useEffect(() => {
        const newKeys = selectedColumns?.map(s => s.key) || [];
        setSelectedColumnKeys(prev => {
            if (
                JSON.stringify(prev) === JSON.stringify(newKeys)
            ) {
                return prev;
            }
            return newKeys;
        });
    }, [selectedColumns]);


    const onSelectField = (column, value) => {
        if (value) {
            setSelectedColumnKeys([...selectedColumnKeys.filter(s => s != column.key), column.key])
        }
        else {
            setSelectedColumnKeys([...selectedColumnKeys.filter(s => s != column.key)])
        }
        setCheckedChanged(true);
    }

    const checked = (column) => {
        return !!selectedColumnKeys?.includes(column?.key);
    }

    const save = async () => {
        onSaveColumns(columns?.filter(s => selectedColumnKeys?.includes(s.key)));
        setCheckedChanged(false);
        closePanel();
    }

    const openPanel = (e) => {
        setAnchorEl(e.currentTarget);
    }

    const closePanel = (e) => {
        setCheckedChanged(false);
        setSelectedColumnKeys(selectedColumns?.map(s => s.key));
        setAnchorEl();
    }

    return (
        <>
            <Tooltip title='Customize Table'>
                <IconButton className={classes.toggleButton} onClick={openPanel}>
                    <IconSettings />
                </IconButton>
            </Tooltip>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={closePanel}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className={classes.content}>
                    <Grid container className={classes.title} justifyContent="space-between" alignItems="center">
                        <div>{title}</div>
                        {isCustomized &&
                            <Tooltip title='You are using a personalized view. Click to reset to the default view.'>
                                <Button color="primary" onClick={onReset}>
                                    {resetting ? 'Resetting...' : 'Reset'}
                                </Button>
                            </Tooltip>
                        }
                    </Grid>
                    <ConfigureColumns checkedChanged={checkedChanged} columns={columns} selectedColumnKeys={selectedColumnKeys} setCheckedChanged={setCheckedChanged} setSelectedColumnKeys={setSelectedColumnKeys} onSelectField={onSelectField} save={save} close={() => setConfigureColumns(false)} />
                    {showTip && <Alert severity='info' className={classes.alert}>
                        Tip: Drag and drop the column headers in the table to customize the order of the columns
                    </Alert>}
                </div>
            </Popover>
        </>
    )
}
export default TableCustomizationPanel;

const ConfigureColumns = ({ columns, selectedColumnKeys, setSelectedColumnKeys, onSelectField, save, checkedChanged, setCheckedChanged }) => {
    const classes = columnCustomizationPanelStyle();
    const allChecked = selectedColumnKeys.length === columns.length;
    const [search, setSearch] = useState("");

    const checked = (column) => {
        return !!selectedColumnKeys?.includes(column?.key);
    }
    const selectAllOptions = (isChecked) => {
        if (isChecked) {
            setSelectedColumnKeys(columns?.map(c => c.key));
        } else {
            setSelectedColumnKeys([]);
        }
        setCheckedChanged(true);
    };

    let columnsWithSelected = columns?.filter(c => c.customizable !== false).map(c => { return { ...c, ["selected"]: checked(c) } })
    const filteredColumns = columnsWithSelected?.filter(col => !col.hideForSelection && col.name?.toLowerCase().includes(search.toLowerCase()));

    return (<div className={classes.columnContainer}>
        <Grid container direction='column' className={classes.columnList}>
            <TextField
                placeholder="Search columns..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                variant="outlined"
                size="small"
                style={{ margin: 12, marginLeft: 0 }}
            />
            <FormControlLabel
                control={<Checkbox
                    checked={allChecked}
                    onChange={(e, value) => selectAllOptions(value)}
                />}
                label="Select All"
            />
            {filteredColumns?.map((column, index) => (
                <Grid item key={column.key}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={column.selected}
                            onChange={(e, value) => onSelectField(column, value)}
                        />}
                        label={column.name}
                    />
                </Grid>
            ))}
        </Grid>
        <Grid container justifyContent="flex-end">
            <Button
                onClick={() => save()}
                variant='outlined'
                color='primary'
                disabled={!checkedChanged}
            >
                Apply
            </Button>
        </Grid>
    </div>)
}